import { useWizardStep } from '@apply/components';
import { useWizardDemoStore } from '../../../../state/wizardDemoStore';
import { getApplicationKeyItemsProgress } from './constants/applicationKeyItemsForm';
import { LoanAmountField } from './components/LoanAmountField';
import { PurchasePriceField } from './components/PurchasePriceField';
import { TargetClosingDateField } from './components/TargetClosingDateField';
import { AllInformationSubmittedField } from './components/AllInformationSubmittedField';
import { OwnerAndCompanyBackgroundField } from './components/OwnerAndCompanyBackgroundField';

/**
 * Demo content for the "Application & Key Items" step. Each field reads and writes its own value in the wizard
 * store; this step enables Save & Continue once every field is complete.
 */
export const ApplicationAndKeyItems = () => {
    const form = useWizardDemoStore((state) => state.applicationKeyItems);
    const { numberComplete, total } = getApplicationKeyItemsProgress(form);

    useWizardStep({ enableSaveAndContinue: numberComplete === total });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '500px' }}>
            <LoanAmountField />
            <PurchasePriceField />
            <TargetClosingDateField />
            <AllInformationSubmittedField />
            <OwnerAndCompanyBackgroundField />
        </div>
    );
};
